import { Divider, Grid2, Paper, Skeleton } from '@mui/material';
import { Box, Container } from '@mui/system';

export const StudentJobOfferDetailSkeleton = () => {
  return (
    <Grid2 container>
      <Grid2 size={{ xs: 12, md: 3 }}>
        <Paper
          sx={{
            height: '100%',
            p: 3,
            borderRadius: 0
          }}
          className="job-offer-detail__contact"
        >
          <Skeleton variant="text" width={180} height={32} sx={{ mb: 2 }} />
          <Box sx={{ my: 3 }}>
            <Grid2 container spacing={1}>
              <Grid2 size={{ xs: 4 }}>
                <Skeleton variant="text" width={60} height={24} />
              </Grid2>
              <Grid2 size={{ xs: 8 }}>
                <Skeleton variant="text" width="100%" height={24} />
              </Grid2>
            </Grid2>
          </Box>

          <Box sx={{ my: 3 }}>
            <Grid2 container spacing={1}>
              <Grid2 size={{ xs: 4 }}>
                <Skeleton variant="text" width={100} height={24} />
              </Grid2>
              <Grid2 size={{ xs: 8 }}>
                <Skeleton variant="text" width="100%" height={24} />
              </Grid2>
            </Grid2>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box sx={{ display: 'flex', aligs: 'center', my: 2 }}>
            <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
            <Skeleton variant="text" width={200} height={24} />
          </Box>

          <Box sx={{ display: 'flex', aligs: 'center', my: 2 }}>
            <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
            <Skeleton variant="text" width={120} height={24} />
          </Box>

          <Box sx={{ mt: 4, display: 'flex', gap: 1 }}>
            <Skeleton variant="rectangular" width="70%" height={36} sx={{ borderRadius: 1 }} />
            <Skeleton variant="rectangular" width="30%" height={36} sx={{ borderRadius: 1 }} />
          </Box>
        </Paper>
      </Grid2>

      {/* Main Content Area Skeleton */}
      <Grid2 size={{ xs: 12, md: 9 }}>
        <Container sx={{ py: 4 }}>
          <Skeleton variant="rectangular" width={60} height={32} sx={{ mb: 2, borderRadius: 16 }} />
          <Skeleton variant="text" width="50%" height={40} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="100%" height={20} />
          <Skeleton variant="text" width="100%" height={20} />
          <Skeleton variant="text" width="90%" height={20} />
          <Skeleton variant="text" width="95%" height={20} />
        </Container>
      </Grid2>
    </Grid2>
  );
};
